	document.addEventListener('alpine:init', () => {
	Alpine.data('sc_popover', (initialConfig) => ({
		cfg: {
			popoverOpen: false,
			popoverPosition: 'bottom', // calculated 'top' or 'bottom'
			popoverOrientation: 'right', // 'left', 'right', 'center'
			popoverWidthClass: 'w-48',
			popoverOffset: 8,
			popoverHeight: 0,
			...initialConfig
		},

		init() {
			// Recalculate on resize or scroll
			const handleUpdate = () => {
				if (this.cfg.popoverOpen) this.calculatePosition()
			}
			window.addEventListener("resize", handleUpdate)
			window.addEventListener("scroll", handleUpdate, true)

			// Watch open state
			this.$watch("cfg.popoverOpen", (value) => {
				if (value) {
					this.$nextTick(() => {
						this.calculatePosition()
						// Focus internal content for accessibility
						if (this.$refs.popoverInner) this.$refs.popoverInner.focus()
					})
				}
			})
		},

		toggle() {
			this.cfg.popoverOpen = !this.cfg.popoverOpen
		},

		close() {
			this.cfg.popoverOpen = false
		},

		// YOUR ORIGINAL CALCULATION LOGIC
		calculatePosition() {
			const btn = this.$refs.popoverButton
			const popover = this.$refs.popover

			// We need to know the height. If it's hidden, we might need a tick or temp display.
			// Assuming x-show handles the display, we check bounds:
			if (!btn || !popover) return;

			// Basic viewport check
			const rect = btn.getBoundingClientRect();
			const spaceBelow = window.innerHeight - rect.bottom;

			// Use specific height if we have it, or estimate/measure
			const requiredSpace = popover.offsetHeight || 200;

			if (spaceBelow < (requiredSpace + this.cfg.popoverOffset + 20)) {
				this.cfg.popoverPosition = "top"
			} else {
				this.cfg.popoverPosition = "bottom"
			}
		},

		popoverMarginStyles() {
			// Returns a string for :style
			const btn = this.$refs.popoverButton
			if (!btn) return ""

			const btnHeight = btn.offsetHeight

			if (this.cfg.popoverPosition === "top") {
				return `margin-bottom: ${btnHeight + this.cfg.popoverOffset}px`
			} else {
				return `margin-top: ${btnHeight + this.cfg.popoverOffset}px`
			}
		},

		popoverPositionStyles() {
			// Returns a string for :class
			let classes = ""

			// Vertical Anchor
			if (this.cfg.popoverPosition === "bottom") {
				classes += "top-0 "
			} else {
				classes += "bottom-0 "
			}

			// Horizontal Anchor
			if (this.cfg.popoverOrientation === "right") {
				classes += "right-0 "
			} else if (this.cfg.popoverOrientation === "left") {
				classes += "left-0 "
			} else if (this.cfg.popoverOrientation === "center") {
				classes += "left-1/2 -translate-x-1/2 "
			}

			classes += ` ${this.cfg.popoverWidthClass} `
			return classes
		}
	}))
})
